/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Track_Intensity_Warm_DescInputs */

const en_ui_track_intensity_warm_desc = /** @type {(inputs: Ui_Track_Intensity_Warm_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twice as bright – single passes clearly visible.`)
};

const de_ui_track_intensity_warm_desc = /** @type {(inputs: Ui_Track_Intensity_Warm_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doppelt so hell – einzelne Runden gut sichtbar.`)
};

/**
* | output |
* | --- |
* | "Twice as bright – single passes clearly visible." |
*
* @param {Ui_Track_Intensity_Warm_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_track_intensity_warm_desc = /** @type {((inputs?: Ui_Track_Intensity_Warm_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Track_Intensity_Warm_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_track_intensity_warm_desc(inputs)
	return de_ui_track_intensity_warm_desc(inputs)
});